import { defineComponent as _defineComponent } from 'vue'
export interface Props extends BFormInput.Props {
  value?: string | null;
  label?: string | null;
  options?: ColorOption[];
  allowCustom?: boolean;
  allowNone?: boolean;
}

/** `FormColor` component emits. */
export type Emits = (event: 'input', value: string | null) => void;

interface ColorOptionItem extends ColorOption {
  key: string;
}


import { ref, computed, defineComponent } from 'vue';
import { BFormInput } from 'bootstrap-vue';
import { uniqueId } from 'lodash';

export interface ColorOption {
  name?: string;
  value: string;
}

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    FormColor: ComponentWithProps<Props>;
  }
}

const DEFAULT_COLOR_OPTIONS = [
  { name: 'Blue', value: '#3379F6' },
  { name: 'Purple', value: '#9B55A3' },
  { name: 'Pink', value: '#E45C9C' },
  { name: 'Red', value: '#EC5F5E' },
  { name: 'Orange', value: '#E8883A' },
  { name: 'Yellow', value: '#F7C844' },
  { name: 'Green', value: '#78B856' },
] as const;

const __default__ = defineComponent({ name: 'FormColor' });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: { default: null },
    label: { default: null },
    options: { default: () => [...DEFAULT_COLOR_OPTIONS] },
    allowCustom: { type: Boolean, default: true },
    allowNone: { type: Boolean, default: true }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((event: 'input', value: string | null) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string | null, label: string | null, options: ColorOption[], allowCustom: boolean, allowNone: boolean };

/**
 * `FormColor` component properties.
 */




const fieldId = `form-color-${uniqueId()}`;

const customColorInput = ref<[HTMLInputElement] | null>(null);

const customColor = ref<string | null>(null);

const colorOptions = computed(() => {
  const items: ColorOptionItem[] = [];

  if (props.allowNone) {
    items.push({
      key: 'none',
      name: 'None',
      value: 'gray',
    });
  }

  items.push(
    ...props.options.map((item) => ({ ...item, key: `color-${uniqueId()}` })),
  );

  if (props.allowCustom) {
    items.push({
      key: 'custom',
      name: 'Custom',
      value:
        customColor.value ?? 'linear-gradient( 90deg,red, orange, skyblue)',
    });
  }

  return items;
});

function setValue(value: string | null) {
  emit('input', value);
}

function onSelection(event: MouseEvent, option: ColorOptionItem) {
  const inputEl = (
    event.target as HTMLLabelElement
  ).parentElement?.querySelector('input');

  console.log(inputEl);

  if (!inputEl) return;

  event.preventDefault();
  inputEl.checked = true;

  // ...
  if (option.key === 'none') return setValue(null);
  // ...
  if (option.key !== 'custom') return setValue(option.value);

  // ...

  setValue(customColor.value);

  const customColorInputEl = customColorInput.value?.[0];

  if (!customColorInputEl) {
    // eslint-disable-next-line no-console
    return console.warn('Unable to find custom color input element.');
  }

  customColorInputEl.click();
}

return { __sfc: true,DEFAULT_COLOR_OPTIONS, props, emit, fieldId, customColorInput, customColor, colorOptions, setValue, onSelection }
}

})